import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ma-liste',
  templateUrl: './ma-liste.component.html',
  styleUrls: ['./ma-liste.component.scss']
})
export class MaListeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
